import { render, staticRenderFns } from "./RatingFilter.vue?vue&type=template&id=4e4ad328&scoped=true"
import script from "./RatingFilter.vue?vue&type=script&lang=js"
export * from "./RatingFilter.vue?vue&type=script&lang=js"
import style0 from "./RatingFilter.vue?vue&type=style&index=0&id=4e4ad328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ad328",
  null
  
)

export default component.exports